module.exports = __webpack_public_path__ + "static/media/track-list1.c73ee6f7.png";